import styled from "styled-components";
import { Button } from "_c/button";

export const Wrap = styled.div`
  @media (max-width: 575px) {
    width: 95%;
    margin-left: auto;
    margin-right: auto;
  }
`;
export const AddSect = styled.div`
  margin-bottom: 15px;
  display: flex;
  justify-content: center;
`;
export const AddSpecBtn = styled(Button)`
  margin: 0;
  padding-bottom: 14px;
`;
